import React from "react";
import { motion } from "framer-motion";
import { ShapeSquare, ShapeFlower } from "./brand/Shapes";

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      className="relative py-14 md:py-28 bg-[#E3EDF9] overflow-hidden"
      data-testid="philosophy-section"
    >
      {/* Decorative */}
      <ShapeSquare
        size={180}
        color="#C6D947"
        className="absolute -top-10 -right-10 opacity-90 rotate-12 hidden md:block"
      />
      <ShapeFlower
        size={120}
        color="#5BC4B8"
        className="absolute bottom-10 left-4 opacity-80 hidden lg:block"
      />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold tracking-[0.22em] uppercase text-[#648DE5] mb-5 block">
              Our Philosophy
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.8 }}
              className="font-display text-[#0F1B47] text-[32px] md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-semibold"
            >
              Slow, intentional,
              <br />
              <span className="italic font-normal">deeply human</span> —
              <br />
              the way early learning
              <br />
              was meant to be.
            </motion.h2>
          </div>

          <div className="lg:col-span-7 grid md:grid-cols-2 gap-6">
            {[
              {
                title: "Play is our pedagogy",
                body: "Every climb, every question, every paint-splashed apron is learning. We plan around play, not despite it.",
                color: "#648DE5",
              },
              {
                title: "Cambridge, taught quietly",
                body: "We bring the Cambridge Early Years framework to life with warmth — rigour without pressure, standards without shouting.",
                color: "#C6D947",
              },
              {
                title: "Teachers who listen",
                body: "Our educators are curious observers first. They document, reflect and build each week around what children show them.",
                color: "#5BC4B8",
              },
              {
                title: "Safe environment",
                body: "Beautiful, child-scale spaces. Real materials. Natural light. Because environment is the third teacher.",
                color: "#3AB0D6",
              },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="bento-card bg-[#FAFAF5] rounded-3xl p-6 md:p-8 border border-[#0F1B47]/8"
                data-testid={`philosophy-card-${i}`}
              >
                <div
                  className="w-10 h-10 rounded-full mb-5"
                  style={{ background: item.color }}
                />
                <h3 className="font-display text-xl md:text-2xl text-[#0F1B47] font-medium mb-3">
                  {item.title}
                </h3>
                <p className="text-[#4A5568] text-sm md:text-[15px] leading-relaxed font-light">
                  {item.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
